/* eslint-disable eqeqeq */
import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import {api, failedReject, successReject, successApprove, failedApprove} from './constants';
import mutations from './mutations';
import state from './state';
import { postApi } from '../../../lib/fetcher';


const approvalInsertFileOffUs = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_APPROVAL_INSERT_FILE_TRANSACTION;

      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const version = generateVersionHash(itemsPerPage.toString() + page.toString(), date);
      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'id DESC',
        version,
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async rejectInsert(ctx, { date, id, remark }) {
      const URL_API = api.SEND_REJECT_INSERT_FILE_TRANSACTION;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Reject');
      ctx.commit('setProgressColor', 'green');

      const version = generateVersionHash(date);
      const data = JSON.stringify({
        ids: id,
        remark,
        version
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;

        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      
      ctx.commit('setIntervalInsert', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successReject(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId);
 
        return failedReject(ctx, responseData); 
    
      } catch (error) {
        clearInterval(intervalId);
 
        return failedReject(ctx)(); 
      } finally {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit('setIntervalInsert', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },
    async checkStatusApproval(ctx, { id, date }) {
      const URL_API = api.CHECK_STATUS_APPROVAL;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Approval');
      ctx.commit('setProgressColor', 'green');

      const version = generateVersionHash(date);
      const data = JSON.stringify({
        import_ids : id,
        version
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;

        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);

      ctx.commit('setIntervalInsert', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successApprove(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId);
 
        return failedApprove(ctx, responseData); 
      } catch (error) {
        clearInterval(intervalId);

        return failedApprove(ctx); 
      } finally {
        clearInterval(ctx.state.intervalInsert);
        ctx.commit('setIntervalInsert', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },

    async approveAndCheck(ctx, { date, id, remark }) {
      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Approval');
      ctx.commit('setProgressColor', 'green');
    
      const version = generateVersionHash(date);
      const payload = JSON.stringify({
        ids: id,
        remark,
        version,
      });
    
      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;
        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1);
        }
      }, 100);
      ctx.commit('setIntervalInsert', intervalId);
    
      try {
        const approveResponse = await postApi(ctx, api.SEND_APPROVE_INSERT_FILE_TRANSACTION, payload);
    
        if (approveResponse?.code === 200) {
          const importIds = approveResponse.data?.importIds;
          
          if (importIds && importIds.length) {
            const checkPayload = JSON.stringify({
              import_ids: importIds,
              version,
            });
    
            const checkStatusResponse = await postApi(ctx, api.CHECK_STATUS_APPROVAL, checkPayload);
    
            if (checkStatusResponse?.code === 200) {
              ctx.commit('setPercentage', 100);
              clearInterval(intervalId);
              successApprove(ctx, checkStatusResponse);
              return true;
            } 
            clearInterval(intervalId);
            return failedApprove(ctx, checkStatusResponse);
            
          } 
          clearInterval(intervalId);
          return failedApprove(ctx, { message: 'Import ID tidak ditemukan.' });
          
        } 
        clearInterval(intervalId);
        return failedApprove(ctx, approveResponse);
        
      } catch (error) {
        clearInterval(intervalId);
        return failedApprove(ctx, error);
      } finally {
        clearInterval(ctx.state.intervalInsert);
        ctx.commit('setIntervalInsert', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500);
      }
    },
    
    async downloadResult(ctx, { date, id }) {
      ctx.commit('setOnDownloadResult', true);
    
      const version = generateVersionHash(date);
      const data = {
        id,
        version,
      };
    
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/${api.DOWNLOAD_RESULT_INSERT_FILE_OFF_US}`,
          data,
          {
            headers: {
              'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram')).token,
              'X-Origin-Path': window.location.pathname
            },
            responseType: 'blob',
          }
        );
    
        const disposition = response.headers['content-disposition'];
        let filename = 'Transaction_File_Off_Us.xlsx';
    
        if (disposition && disposition.includes('filename=')) {
          const [, extractedFilename] = disposition?.match(/filename="?([^"]+)"?/) || [];
          if (extractedFilename) {
            filename = extractedFilename;
          }
          
        }
    
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    
        ctx.commit('setOnDownloadResult', false);
      } catch (error) {
        ctx.commit('setOnDownloadResult', false);
        ctx.commit('setSnackbar', {
          status: true,
          message: 'Download failed!',
          icon: 'mdi-alert',
          color: 'red',
        }, { root: true });
      }
    },
    
    
    closeProgressBar({ commit }) {
      commit('setShowProgressBar', false);
    },
  },
};

export default approvalInsertFileOffUs;
